export class SearchProjects {
    public static readonly type = "[Projects] Search projects";

    constructor(public payloadSearchQuery: string) {}
}
